/** @jsx jsx */
// eslint-disable-next-line
import React from 'react'
import { css, jsx } from '@emotion/core'
import { useSelector } from 'react-redux'
import Header from './components/Header'
import Calendar from './components/Calendar'
import ReminderModal from './components/ReminderModal'
import { palette } from './constants'

const headerHeight = 50

const styles = {
  container: css`
    display: flex;
    flex-direction: column;
    height: 100%;

    & .hover {
      transition: transform 0.1s ease-in-out;

      &:hover {
        transform: scale(1.03);
      }
    }
  `,
  calendarWrapper: css`
    flex: 1;
    padding: 10px;
    background: ${palette.white};
  `,
}

function App() {
  // We want this component to be the one that fetch data from the store
  const date = useSelector(state => state.calendar.date)
  const showModal = useSelector(state => state.calendar.showModal)
  const reminders = useSelector(state => state.calendar.reminders)
  const editingReminder = useSelector(state => state.calendar.editingReminder)

  return (
    <div css={styles.container}>
      <Header height={headerHeight} date={date} />
      <div css={styles.calendarWrapper}>
        <Calendar date={date} reminders={reminders} />
      </div>
      {showModal && <ReminderModal isEditing={!!editingReminder} date={date} reminderEditing={editingReminder} />}
    </div>
  )
}

export default App
